var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7931A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.5,0c-0.5,0.2-0.9,0.4-1.4,0.5C233.6,0.5,234.1,0.4,234.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,278c0.2,0.3,0.3,0.7,0.5,1C0.4,278.7,0.3,278.3,0,278z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.4,240.4c-0.3-8.8-0.2-17.6-1.7-26.3c-7.9-48.5-28.2-91.4-60.5-128.2c-26.7-30.5-58.9-53.7-96.5-69 c-17.7-7.2-35.9-12.9-55-15.2c-7-0.8-14.2-0.4-21.2-1.7c-1.7,0-3.3,0-5,0c-2.3,1.7-4.7,1.3-7,0c-4.7,0-9.3,0-14,0c-2,1.4-4,1.4-6,0 c-3.3,0-6.7,0-10,0c-0.4,0.4-0.9,0.5-1.4,0.5c-5,1.7-10.3,1.5-15.4,2.2C108.7,19.4,23,103.1,3.9,211.8c-1.1,6.4-1.8,12.8-2.8,19.3 c-0.2,1.1,0.4,2.4-1.1,3c0,1.7,0,3.3,0,5c1.6,1.3,1.2,2.7,0,4c0,6,0,12,0,18c1.4,2,1.4,4,0,6c0,3.7,0,7.3,0,11 c0.3,0.3,0.4,0.7,0.5,1c2,4.9,1.6,10.2,2.4,15.3c15.8,107.7,101,195.3,208,213.7c6.5,1.1,13.1,1.9,19.7,2.8c1.1,0.2,2.4-0.4,3,1.1 c2,0,4,0,6,0c2-1.6,4-1.3,6,0c5,0,10,0,15,0c1.7-1.3,3.3-1.4,5,0c3.7,0,7.3,0,11,0c1-0.9,2.2-0.4,3.3-0.5 c8.3-0.6,16.6-0.6,24.7-2.1c28-5.2,54.4-15,79.1-29.3c25.5-14.8,48.1-33.2,67.3-55.6c16.8-19.7,30.6-41.4,40.9-65.3 c8.5-19.6,15.1-39.9,17.9-61.1C512.2,279,512,259.7,511.4,240.4z M253.3,384.2c-70.5-1.2-126.6-59.7-125.8-130.6 c0.8-68.7,58.2-125.6,128.3-125.6c71.4,0,128,57.3,127.6,130.1C382.9,328.7,324,385.4,253.3,384.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.5,0c-2.3,0-4.7,0-7,0C266.8,0.8,269.1,0.8,271.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.5,0c-2.3,0.8-4.7,0.8-7,0C266.8,1.3,269.1,1.7,271.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.5,0c-2,0-4,0-6,0C246.5,0.8,248.5,0.8,250.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.5,0c-2,0.8-4,0.8-6,0C246.5,1.4,248.5,1.4,250.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,261c0,2,0,4,0,6C0.8,265,0.8,263,0,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,261c0.8,2,0.8,4,0,6C1.4,265,1.4,263,0,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.5,512c2,0,4,0,6,0C243.5,511.2,241.5,511.2,239.5,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.5,512c2-0.8,4-0.8,6,0C243.5,510.7,241.5,510.4,239.5,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.5,512c1.7,0,3.3,0,5,0C263.8,511.2,262.2,511.2,260.5,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.5,512c1.7-0.8,3.3-0.8,5,0C263.8,510.6,262.2,510.7,260.5,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,239c0,1.3,0,2.7,0,4C0.8,241.7,0.8,240.3,0,239z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,239c0.8,1.3,0.8,2.7,0,4C1.2,241.7,1.6,240.3,0,239z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.f288e3b16b1817ef83a2c27359fa96df.svg";
export { ForwardRef as ReactComponent };